export const COLEGIOS = [
  { codigo: "07546", nombre: "ALIC NEW WORLD SCHOOL" },
  { codigo: "07549", nombre: "ELIGIO CONTRERAS" },
  { codigo: "07550", nombre: "CENTRO DE EDUCACION INTEGRAL ERCILIA PEPIN" },
  { codigo: "07553", nombre: "BAUTISTA EL MAESTRO" },
  { codigo: "07557", nombre: "CENTRO EDUCATIVO BAUTISTA PABLO SIEBENMANN" },
  { codigo: "07558", nombre: "MARY LITHGOW" },
  { codigo: "07562", nombre: "SANTA ROSA DE LIMA" },
  { codigo: "07579", nombre: "COSTAMBAR" },
  { codigo: "07583", nombre: "MUNDO FELIZ" },
  { codigo: "07584", nombre: "SAN JOSE" },
  { codigo: "07595", nombre: "SAN FELIPE APOSTOL" },
  { codigo: "07677", nombre: "NAZARET" },
  { codigo: "07678", nombre: "COLEGIO ENRIQUILLO DE JARAGUA" },
  { codigo: "07687", nombre: "UTESIANO DE ESTUDIOS INTEGRADOS-CUEI-UTESA" },
  { codigo: "07692", nombre: "COLEGIO EVANGELICO CARRUSEL DE AMOR" },
  { codigo: "07695", nombre: "EL EDEN" },
  { codigo: "07696", nombre: "EUNICE GARCIA" },
  { codigo: "07697", nombre: "COMUNIDAD DE NIÑOS MONTESSORI" },
  { codigo: "07703", nombre: "NIDO DE ESPERANZA" },
  { codigo: "07717", nombre: "LUMBRERA DEL SABER (ELVIA CAMPILLO)" },
  { codigo: "07718", nombre: "COLEGIO CRISTIANO OASIS" },
  { codigo: "07719", nombre: "FUENTE DE ESPERANZA" },
  { codigo: "07728", nombre: "O&M HOSTOS SCHOOL" },
  { codigo: "07729", nombre: "APRENDIENDO CON ALEGRIA" },
  { codigo: "07730", nombre: "CENTRO INFANTIL CAMINITO" },
  { codigo: "07731", nombre: "COLEGIO LOS NINOS ANDANDO CON JESÚS (CNAJ)" },
  { codigo: "10756", nombre: "COLEGIO BIBLICO JARDIN DE YVEL" },
  { codigo: "10835", nombre: "CENTRO EDUCATIVO CASITA FELIZ" },
  { codigo: "11425", nombre: "CENTRO EDUCATIVO SEMBRANDO ESPERANZA" },
  { codigo: "14144", nombre: "ADR-CEAMD - DRA. DELSA VASQUEZ" },
  { codigo: "14573", nombre: "COLEGIO EVANGELICO MESSIAH" },
  { codigo: "15123", nombre: "ACADEMIA INTERNACIONAL ATLAS" },
  { codigo: "16667", nombre: "GUARDERIA ONEYLIA" },
];

export function buscarColegios(query) {
  if (!query || query.length < 1) return COLEGIOS;
  const q = query.toLowerCase();
  return COLEGIOS.filter(c =>
    c.nombre.toLowerCase().includes(q) || c.codigo.includes(q)
  );
}
